import {BaseComponent, Collapse} from 'bootstrap';
import {isNil, queryStringValue} from "../Helper";

/**
 * This class handles opening a RealEstate from a RealEstateGroup if
 * there is a query string ?realEstate=[node-identifier] in the URL.
 *
 * If there is more than one item in the accordion (i.e. more than one
 * RealEstate in the RealEstateGroup), the respective accordion item is
 * opened if found.
 *
 * The accordion itself is initialized automagically through HTML
 * classes.
 */
export default function realEstateGroupAccordion() {

    const realEstateIdentifier = queryStringValue('realEstate');
    if (!isNil(realEstateIdentifier)) {
      const realEstateGroup = document.querySelector('.bgr-realestate-group');
      const numberOfRealEstatesInGroup = realEstateGroup.querySelectorAll('.accordion-item').length;
      // If we have only 1 element, it is already open by default
      if (numberOfRealEstatesInGroup > 1) {
        const accordionElement = realEstateGroup.querySelector('#collapse-' + realEstateIdentifier);
        if (!isNil(accordionElement)) {
          const collapse = Collapse.getOrCreateInstance(accordionElement);
          collapse.show();
        }
      }
    }
}
